import script from "./alipay-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./alipay-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./alipay-recharge-dialog.vue?vue&type=style&index=0&id=b48c8982&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b48c8982"]])

export default __exports__